import { PropTypes } from 'typed/imports';
import { ComponentEventHandler1, PureComponent, ReactEventHandler } from 'typed/components/utils';
import './Checkbox.less';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const NOOP = () => { };

export enum Appearance {
    CHECKBOX = 'CHECKBOX',
    BUTTON = 'BUTTON',
    SWITCH = 'SWITCH',
    RADIO = 'RADIO'
}

export interface Props {
    value?: boolean;
    appearance?: Appearance;
    disabled?: boolean;
    className?: string;
    onChange?: ComponentEventHandler1<boolean>;
}

export default class Checkbox extends PureComponent<Props> {
    static readonly Appearance = Appearance;

    static readonly propTypes = {
        value: PropTypes.bool,
        appearance: PropTypes.oneOf(Object.values(Appearance)),
        className: PropTypes.string,
        disabled: PropTypes.bool,
        onChange: PropTypes.func
    };

    static readonly defaultProps = {
        value: false,
        appearance: Appearance.CHECKBOX,
        disabled: false,
        className: ''
    };

    private _id = `checkbox${Math.random() * Number.MAX_SAFE_INTEGER | 0}`;

    private _onChange: ReactEventHandler = (event) => {
        if (!this.props.disabled && this.props.onChange) {
            this.props.onChange(this, this.props.appearance !== Appearance.CHECKBOX ? !this.props.value : (event.target as any).checked);
            event.stopPropagation();
            if (this.props.appearance !== Appearance.CHECKBOX) {
                event.preventDefault();
            }
        }
    };

    render() {
        const { value, appearance, disabled, className, children } = this.props;

        switch (appearance) {
            case Appearance.CHECKBOX:
                return (
                    <div className={`checkbox appearance-checkbox ${disabled ? 'disabled ' : ''} ${className}`}>
                        <input type="checkbox" disabled={disabled} id={this._id} name={this._id} value={`${value}`} checked={value} onChange={this._onChange} />
                        <label htmlFor={this._id}>{children}</label>
                    </div>
                );

            case Appearance.BUTTON:
                return (
                    <div className={`checkbox appearance-button ${disabled ? 'disabled ' : ''} ${className}`}>
                        <button className={value ? 'primary' : 'secondary'} disabled={disabled} onClick={this._onChange}>{children}</button>
                    </div>
                );

            case Appearance.SWITCH:
                return (
                    <div className={`checkbox appearance-switch ${disabled ? 'disabled ' : ''} ${className}`}>
                        {/* TODO implement turning on and off by sliding, for now suppress warnings */}
                        <input id={this._id} type="range" min="0" max="1" value={+value!} disabled={disabled} onClick={this._onChange} onChange={NOOP} />
                        <label htmlFor={this._id} onClick={this._onChange}>{children}</label>
                    </div>
                );

            case Appearance.RADIO:
                return (
                    <div key={+(value || false)} className={`checkbox appearance-radio ${disabled ? 'disabled ' : ''} ${className}`}>
                        <input type="checkbox" disabled={disabled} id={this._id} name={this._id} value={`${value}`} checked={value} onChange={this._onChange} />
                        <label htmlFor={this._id}>{children}</label>
                    </div>
                );

            default: throw new Error(`Unknown Appearance: ${appearance}.`);
        }
    }
}
